import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Canonical class-name merge for the entire EduViaOS frontend. clsx
 * normalises arrays/objects/conditional inputs, twMerge dedupes
 * conflicting Tailwind utilities (e.g. `px-2 px-4` -> `px-4`).
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
